// AUTO-GENERATED by scripts/gen-corpus-tops.ts — do not edit by hand.
export const MASTER_KEYWORDS_TOP: string[] = [
  "บริการแปลโดยนักแปลวิชาชีพ NAATI",
  "NAATI certified translation online global service",
  "แปลเอกสารยื่นวีซ่าออสเตรเลีย NAATI",
  "cross-language NAATI translation to english",
  "แปลจดหมายแนะนำตัวยื่นวีซ่าออสเตรเลีย",
  "bank statement translation by NAATI translator",
  "นักแปลขึ้นทะเบียนกระทรวงยุติธรรม ไทย",
  "MoJ certified legal translation thailand",
  "แปลสำนวนการสอบสวนพร้อมรับรองกระทรวงยุติธรรม",
  "thai court judgment translation MoJ certified",
  "แปลนิติกรรมสัญญาโดยนักแปลกระทรวงยุติธรรม",
  "นักแปลสาบานตน สถานทูตฝรั่งเศส",
  "french sworn translator in thailand",
  "นักแปลสาบานตน สถานทูตเยอรมนี",
  "german sworn translator for legal documents",
  "นักแปลสาบานตน สถานทูตกลุ่มเชงเก้น",
  "italian sworn translator embassy approved",
  "spanish sworn translator visa application",
  "แปลเอกสารจดทะเบียนสมรสฝรั่งเศส Sworn Translator",
  "บริการประทับตราศูนย์แปล Certified True Translation",
  "resume and cover letter translation agency",
  "แปล SOP เพื่อเรียนต่อต่างประเทศ",
  "website localization and brochure translation",
  "ทนายความรับรองเอกสาร Notarial Services Attorney",
  "บริการรับรองลายมือชื่อ Notary Public",
  "signature authentication by thai notary",
  "บริการรับรองสำเนาถูกต้อง พาสปอร์ต",
  "certified true copy passport thailand",
  "บริการรับรองบุคคล กรรมการบริษัท Notary",
  "authentication of person and corporate entity",
  "expat notary services in bangkok",
  "ทำหนังสือสาบานตน Affidavit สำหรับชาวต่างชาติ",
  "บริการขอรับรองเอกสารแบบ Apostille",
  "Apostille legalization services in thailand",
  "ขอตราประทับ Apostille สำหรับประเทศเกาหลีใต้",
  "hague convention document apostille thailand",
  "บริการประสานงาน Apostille เอกสารต่างประเทศ",
  "รับรองสถานทูตแบบครบวงจร สถานทูตจีน",
  "UAE embassy legalization service thailand",
  "รับรองเอกสารพาณิชย์ หอการค้าไทย",
  "commercial invoice board of trade certification",
  "รับรองเอกสารวิชาชีพโดยแพทยสภา",
  "medical council of thailand document certification",
  "บริการแปลพร้อมรับรองสภาวิศวกร",
  "engineering council license legal translation",
  "ทนายรับรองเอกสารเปิดบัญชีธนาคารต่างประเทศ",
  "notary certification for overseas bank account",
  "รับรองเอกสารสถานทูตสเปนและอิตาลี",
  "แปลเอกสารชั้นศาลพร้อมประทับตราทนาย",
  "certified translation with notarial seal",
  "บริการแปลหนังสือมอบอำนาจสองภาษา",
  "bilingual power of attorney drafting and translation",
  "แปลเอกสารยื่นวีซ่าทักษะวิชาชีพนิวซีแลนด์",
  "skilled migration visa translation NAATI",
  "นักแปลสาบานตนสถานทูตสวิตเซอร์แลนด์",
  "swiss embassy sworn translator bangkok",
  "นักแปลสาบานตนสถานทูตออสเตรีย",
  "austrian embassy sworn translator service",
  "แปลรายงานประจำปีบริษัท (Annual Report)",
  "corporate annual report translation service",
  "แปลคู่มือวิศวกรรมเฉพาะทาง",
  "technical engineering manual translation",
  "แปลเอกสารการแพทย์และงานวิจัย",
  "medical journal and research paper translation",
  "แปลซับไตเติลวิดีโอโฆษณาเชิงพาณิชย์",
  "commercial video subtitle translation",
  "รับรองคำแปลสำหรับยื่นประมูลงานต่างประเทศ",
  "certified translation for international bidding",
  "แปลเอกสารนำเข้าส่งออกหอการค้า",
  "export document translation board of trade",
  "รับรองสถานทูตเวียดนาม ประจำประเทศไทย",
  "vietnamese embassy legalization bangkok",
  "บริการขอ Apostille กรมการกงสุล",
  "thai MFA apostille stamp service",
  "รับรองใบอนุญาตสภาการพยาบาล",
  "nursing council license certification for abroad",
  "นักแปล MoJ สำหรับคดีความระหว่างประเทศ",
  "ministry of justice translator for cross-border litigation",
  "แปลเอกสารแสดงความสัมพันธ์ยื่นวีซ่า",
  "relationship evidence translation for visa",
  "แปลและรับรองเรซูเม่สมัครงานต่างประเทศ",
  "certified CV translation for overseas employment",
  "ทนายความรับรองสัญญาเช่าชาวต่างชาติ",
  "notary public for expat lease agreement",
  "แปลหมายจับและหมายเรียกศาล",
  "court summons and arrest warrant translation",
  "นักแปลสาบานตนสถานทูตเบลเยียม",
  "belgian embassy sworn translator thailand",
  "แปลเอกสารไอทีและซอฟต์แวร์ธุรกิจ",
  "IT and business software translation",
  "บริการแปลสัญญาการค้าสองภาษา",
  "dual-language commercial contract translation",
  "รับรองเอกสาร Certificate of Origin",
  "CO document embassy legalization",
  "แปลสเตทเม้นท์ธนาคารพร้อมตราประทับ",
  "official bank statement translation with stamp",
  "ทนายโนตารีรับรองหนังสือเดินทางต่างชาติ",
  "foreign passport notarization by thai attorney",
  "แปลเอกสารยื่นสถานทูตเนเธอร์แลนด์",
  "dutch embassy document translation bangkok",
  "บริการล่ามศาลและกระบวนการยุติธรรม",
  "professional court and legal interpreter thailand",
  "ล่ามประจำศาล คดีแพ่งและคดีอาญา",
  "civil and criminal court interpreter",
  "ล่ามชั้นพนักงานสอบสวน สถานีตำรวจ",
  "police station inquiry interpreter",
  "ล่ามคดีแรงงานและศาลชำนัญพิเศษ",
  "labor court specialized interpreter",
  "ล่ามเจรจาไกล่เกลี่ยข้อพิพาทและประนอมหนี้",
  "dispute mediation and arbitration interpreter",
  "ล่ามทำนิติกรรมสัญญาหน้าเจ้าพนักงานที่ดิน",
  "real estate transaction legal interpreter",
  "ล่ามติดต่อหน่วยงานราชการสำหรับชาวต่างชาติ",
  "government liaison interpreter for expats",
  "ล่ามประจำที่ว่าการอำเภอ จดทะเบียนสมรส",
  "district office marriage registration interpreter",
  "ล่ามสัมภาษณ์วีซ่าสถานทูต",
  "embassy visa interview interpreter",
  "ล่ามติดต่อสำนักงานตรวจคนเข้าเมือง ตม.",
  "thai immigration office interpreter",
  "บริการล่ามตู้ ล่ามแปลพร้อม",
  "simultaneous interpreting services thailand",
  "ล่ามงานประชุมสัมมนาระดับนานาชาติ",
  "international conference simultaneous interpreter",
  "บริการจัดหาอุปกรณ์หูฟังและตู้ล่าม",
  "AV rental and interpretation equipment setup",
  "ล่ามแปลต่อเนื่อง สำหรับเจรจาธุรกิจ",
  "consecutive interpreting for business meetings",
  "ล่ามนำเสนอโครงการ Pitching",
  "executive business pitching interpreter",
  "ล่ามงานแสดงสินค้าและจับคู่ธุรกิจ",
  "trade show and business matching interpreter",
  "ล่ามลงพื้นที่และเยี่ยมชมโรงงาน",
  "factory visit and audit technical interpreter",
  "บริการล่ามทางการแพทย์และสุขภาพ",
  "medical and healthcare interpreter thailand",
  "ล่ามโรงพยาบาลสำหรับ Medical Tourist",
  "hospital interpreter for medical tourists",
  "ล่ามคลินิกศัลยกรรมความงามและทันตกรรม",
  "aesthetic and dental clinic interpreter",
  "ล่ามประสานงานเคลมประกันสุขภาพ",
  "medical insurance claim coordinator interpreter",
  "ล่ามติดตามส่วนตัว Escort Interpreter",
  "VIP escort interpreter for expats",
  "ล่ามพาทัวร์ดูอสังหาริมทรัพย์ Property Viewing",
  "real estate viewing escort interpreter",
  "บริการล่ามทางไกลผ่านวิดีโอ VRI",
  "video remote interpreting VRI zoom teams",
  "บริการล่ามผ่านทางโทรศัพท์ OPI เร่งด่วน",
  "over-the-phone interpreting OPI service"
];
export const MASTER_KEYWORDS_TOTAL = 985;
export const MASTER_QUESTIONS_TH_TOTAL = 384;
export const MASTER_QUESTIONS_EN_TOTAL = 400;
